import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

function StatusIcon({ value }) {
    if (value) {
        return <i className="fa fa-check cms-categories-status-on" aria-label="Enabled"></i>;
    }
    return <i className="fa fa-remove cms-categories-status-off" aria-label="Disabled"></i>;
}

function RowActions({ id, showDelete, onDelete }) {
    return (
        <div className="btn-group cms-row-actions">
            {showDelete && (
                <button
                    type="button"
                    onClick={() => {
                        if (window.confirm('Are you sure you wish to delete this item?')) {
                            onDelete(id);
                        }
                    }}
                    className="btn btn-default btn-sm cms-row-action-btn cms-row-action-btn-danger"
                >
                    <i className="fa fa-trash"></i>
                </button>
            )}
            <a href={`/cms/categories/${id}`} className="btn btn-default btn-sm cms-row-action-btn">
                <i className="fa fa-edit"></i>
            </a>
        </div>
    );
}

export default function CategoriesTableWidget({ categories, loadingId, showDelete, onDelete, onDragEnd }) {
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <table className="table table-striped cms-list-table cms-categories-table mb-0">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Featured</th>
                        <th></th>
                    </tr>
                </thead>
                <Droppable droppableId="categories-droppable">
                    {(dropProvided) => (
                        <tbody ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
                            {categories &&
                                categories.map((item, index) => (
                                    <React.Fragment key={item.id}>
                                        <Draggable draggableId={`${item.id}`} index={index}>
                                            {(provided) => (
                                                <tr
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    ref={provided.innerRef}
                                                    className={loadingId === item.id ? 'loading cms-categories-parent-row' : 'cms-categories-parent-row'}
                                                >
                                                    <td>
                                                        <p className="mb-0">
                                                            <b>{item.title}</b>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <StatusIcon value={item.status} />
                                                    </td>
                                                    <td>
                                                        <StatusIcon value={item.is_featured} />
                                                    </td>
                                                    <td className="text-right">
                                                        <RowActions id={item.id} showDelete={showDelete} onDelete={onDelete} />
                                                    </td>
                                                </tr>
                                            )}
                                        </Draggable>

                                        {item.childs?.map((child) => (
                                            <tr
                                                key={child.id}
                                                className={loadingId === child.id ? 'loading cms-categories-child-row' : 'cms-categories-child-row'}
                                            >
                                                <td>
                                                    <p className="mb-0 cms-categories-child-title">{child.title}</p>
                                                </td>
                                                <td>
                                                    <StatusIcon value={child.status} />
                                                </td>
                                                <td>
                                                    <StatusIcon value={child.is_featured} />
                                                </td>
                                                <td className="text-right">
                                                    <RowActions id={child.id} showDelete={showDelete} onDelete={onDelete} />
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            {dropProvided.placeholder}
                        </tbody>
                    )}
                </Droppable>
            </table>
        </DragDropContext>
    );
}
